exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fl-checkbox{font-weight:300;font-size:16px;color:#fff;cursor:pointer}.fl-checkbox label{font-weight:300;position:relative}.fl-checkbox .fancy-checkbox input[type=checkbox]{display:none}.fl-checkbox .fancy-checkbox span:before{font-family:FontAwesome,sans-serif;font-size:20px;content:\"\\F096\";position:absolute;left:-26px;top:1px}.fl-checkbox .fancy-checkbox input[type=checkbox]:checked~span:before{content:\"\\F14A\"}", ""]);

// exports
